export const UNREAD_CATEGORY_ID = 'unread';
